import {Trans} from '@lingui/macro';
import {Divider} from '@material-ui/core';
import React from 'react';
import {StageGrid} from '../component/index';
const StagePage = (props) => {
  return (
    <>
      <h2 className="TitleGrid">
        <Trans>Instances</Trans>
      </h2>
      <Divider variant="middle" style={{marginBottom: 10}} />
      <StageGrid />
    </>
  );
};

export default StagePage;
